import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";
import Spinner from "components/ui/Spinner";

const ProviderHome = lazy(() => import("./page/home"));
const ProviderChannelSetting = lazy(() => import("./page/channelSetting"));
const RssPage = lazy(() => import("./page/rss"));
const Chart = lazy(() => import("./components/homeChart"));
const Revenue = lazy(() => import("../profit/Profit"));
const NotFound = lazy(() => import("pages/404"));

/**
 * 콘텍스트 관련 라우터 정리
 */
function ProviderRoutes(): JSX.Element {
  return (
    <Routes>
      <Route
        index
        element={
          <Suspense fallback={<Spinner text="로딩중입니다." />}>
            <ProviderHome />
          </Suspense>
        }
      />

      <Route
        path="setting"
        element={
          <Suspense fallback={<Spinner text="로딩중입니다." />}>
            <ProviderChannelSetting />
          </Suspense>
        }
      />
      <Route
        path="setting/rss/*"
        element={
          <Suspense fallback={<Spinner text="로딩중입니다." />}>
            <RssPage />
          </Suspense>
        }
      />

      <Route
        path="revenue"
        element={
          <Suspense fallback={<Spinner text="로딩중입니다." />}>
            <Revenue />
          </Suspense>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
export default ProviderRoutes;

export function LazyChart() {
  return (
    <>
      <Suspense>
        <Chart />
      </Suspense>
    </>
  );
}
